export const art70 = [
    // {
    //     "nombre": "Hipervinculo a los Planes de Desarrollo Urbano",
    //     "url": "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/a70_f01_f1.xlsx",
    // },
    {
        "nombre": "Planes y Programas de desarrollo Urbano",
        "url": "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/1f.xlsx",
    },
    {
        "nombre": "Planes y Programas de Ordenamiento Territorial",
        "url": "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/2f.xlsx",
    },
    {
        "nombre": "Tipos de Uso del Suelo",
        "url": "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/4f.xlsx",
    },
    {
        "nombre": "Licencias de Uso del Suelo",
        "url": "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/5f.xlsx",
    },
    {
        "nombre": "Licencias de Construcción",
        "url": "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/6f.xlsx",
    },
    {
        "nombre": "Disposiciones administrativas",
        "url": "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art70/f01_g.xlsx",
    }
]